<template>
  <div class="indexPage footerPosition">
    <!----顶部开始----Start--->
    <div class="top-scroll">
      <topInfo></topInfo>
      <!----顶部----END--->
      <!----广告图开始----Start--->
      <div class="about-ad">
        <div class="about-adbox">
          <span v-if="isShowContent==1"><img src="../../../assets/aboutImg/about-ad1.jpg" /></span>
          <span v-if="isShowContent==2"><img src="../../../assets/aboutImg/about-ad4.jpg" /></span>
          <span v-if="isShowContent==3"><img src="../../../assets/aboutImg/about-qa.png" /></span>
        </div>
      </div>
      <!----广告图开始----end--->
    </div>
    <!----nav----Start--->
    <div id="sooptions" class="about-nav">
      <div class="about-navbox">
        <ul>
          <li :class="{chkOn:isShowContent==1}" @click="clkAbout(1)">
            <span v-if="isShowContent==1" class="arrow-up"></span>ABOUT FREIGHTSHOP
          </li>
          <li :class="{chkOn:isShowContent==2}" @click="clkAbout(2)">
            <span v-if="isShowContent==2" class="arrow-up"></span>CONTACT US
          </li>
          <li :class="{chkOn:isShowContent==3}" @click="clkAbout(3)">
            <span v-if="isShowContent==3" class="arrow-up"></span>Q&A
          </li>
        </ul>
      </div>
    </div>
    <!----nav----end--->
    <!----about us----Start--->
    <div v-if="isShowContent==1">
      <div class="cul-box-gray">
        <div class="cul-item">
          <div class="item-le"><img src="../../../assets/aboutImg/cul-images1.jpg"></div>
          <div class="item-ri">
            <div class="title"><strong>Meet Freightshop</strong></div>
            <!-- <p class="mtb-1">Freightshop is established in 2014 Targeting at cross boarder smart logistics and ecommerce services platform, in less than 3 years, Freightshop has been evolved and developed based on rapid technology transformation and market demand. Freightshop has been highly recognized by international users.</p>
            <p class="mtb-1">Freightshop technology puts great focuses on trading innovation, research and business development. It is a state-level high-tech enterprise, with several patents and intellectual property rights. The company also emphasizes on human-based management to promote and encourage happy, positive and progressive working atmosphere.
            <p class="mtb-1">
            Freightshop help enterprises to reduce the cost of communications, improve order efficiency, and allow users to enjoy a fast and satisfactory international logistics services.
            </p> -->

            <p class="mtb-1">
              Freightshop was founded in 2014, and its goal is to build a cross-border intelligent logistics service platform. Through freightshop platform, online inquiry, online ordering, online tracking information, online payment and online communication are realized.
            </p>
            <p class="mtb-1">
              Freightshop integrates the core prices of more than 110 airlines to provide competitive prices and services for international freight forwarders.
            </p>
            <p class="mtb-1">
              Freightshop helps foreign freight forwarders to reduce communication costs, not affected by time difference, improve order efficiency, and enable terminal customers to enjoy fast and satisfactory international logistics services.
            </p>
          </div>
        </div>
      </div>
      <div class="cul-box-white">
        <div class="cul-item marBot50">
          <div class="item-le2">
            <div class="title2"><strong>Freightshop Mission</strong></div>
            <P class="mtb-1"><b>Make international logistics easier through technological innovation and professional services.</b></P>
            <p>Through the large data logistics resources matching and information exchange, Freightshop creates a standardized one-stop platform. We guarantee information transparency, operation efficiency, credit security, and quality international logistics services.</p>
          </div>
          <div class="item-ri2">
            <img src="../../../assets/aboutImg/cul-images2.jpg">
          </div>
        </div>
      </div>
    </div>
    <div v-if="isShowContent==2">

      <div class="cont-all">
        <div class="coop-cont">
          <div class="coop-header">
            <span><img src="../../../assets/aboutImg/coop-taking.png"></span>
            <h3>CONTACT US</h3>
            <span class="lineBlock"></span>
          </div>
          <div class="contact-box">
            <div class="conUsL">
              <span class="conIcon"><img class="l marR10" src="../../../assets/aboutImg/contact-icon1.png"> <b class="l">PHONE: </b></span>
              <div class="conLText">
                <p>Mr. Vincent Zhang: +86 13798479219 Ext 1 (9: 00-18: 00) </p>
                <p>Complaints: +86 13798479219 Ext 0 (9: 00-18: 00)</p>
              </div>
            </div>
            <p class="conUsR">
              <span class="l"><img class="marR5" src="../../../assets/aboutImg/contact-icon2.png"></span>
              <b>ONLINE： </b>
              <em>Email: Support@freightshop.com</em>
            </p>
            <div class="cl"></div>

            <div class="conUsL2 marTop30">
              <div class="conIcon"><img class="l marR10" src="../../../assets/aboutImg/contact-icon3.png"> <b class="l">HEADQUARTERS ADDRESS:</b></div>
              <div class="conLText">
                <!-- <p>Forstreet London Ltd,238 Hedge Lane, Palmers Green, London, England, N13 5DA</p> -->
                <p>FREIGHTSHOP FREIGHT CO.,LTD</p>
                <!-- <p>CHASE BUSINESS CENTRE 39-41 CHASE SIDE, LONDON, UNITED KINGDOM N14 5BP</p> -->
                <p>Office Address: A World Trade Plaza Fuhong Rd Futian District -ShenZhen City China</p>

                <!-- <p>Shenzhen</p>
                <p>Floor 27, Block A, World Trade Plaza, Fuhong RD, Futian District, Shenzhen, China</p>
                <p>Zip code: 518033</p> -->
              </div>
            </div>
            <!--<p class="conUsR">-->
            <!--<span class="l"><img src="../../../assets/aboutImg/contact-icon3.png"></span>-->
            <!--<b>HEADQUARTERS ADDRESS：</b>-->
            <!--<em>Shenzhen<br />Room 2906, Floor 29, Block A, World Trade Plaza, Fuhong RD, Futian District, Shenzhen,<br />Zip code: 518033</em></p>-->
          </div>
        </div>
      </div>

    </div>
    <div v-if="isShowContent==3">
      <QA></QA>
    </div>
    <!----bout us----end--->
    <!----网站底部结束----start--->
    <div style="clear:both;"></div>
    <footerInfo></footerInfo>
    <!----网站底部结束----end--->
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue';
import { post, fetch, Del, put } from "../../../ask/axios";
import { getCookie, delCookie } from '../../../ask/cookiejs'
import topInfo from '../public/topInfo'
import footerInfo from '../public/footerInfo'
import QA from '../otherPage/QA.vue'

export default {
  components: { topInfo, footerInfo, QA },
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      isShowContent: 1,
      //用户名
      userName: '',
    }
  },
  created() {
    if (this.$route.query.abUs) {
      this.isShowContent = this.$route.query.abUs
    };

    // let token = getCookie('X-BY-EnTOKEN')
    // console.log('getToken333：' +  token)
  },
  mounted() { //dom已经生成

  },
  methods: {


    //点击切换
    clkAbout(val) {
      switch (val) {
        case 1:
          this.isShowContent = 1
          break;
        case 2:
          this.isShowContent = 2
          break;
        case 3:
          this.isShowContent = 3
          break;

        default:
          break;
      }
    },
  }
}
</script>
<style scoped>
@import "../../../assets/css/about.css";
</style>



// WEBPACK FOOTER //
// src/components/reception/otherPage/aboutUs.vue